import { useContext, useState } from "react";
import { Alert, ButtonGroup, Intent, NumericInput } from "@blueprintjs/core";

import PageContext from "../Context/PageContext";

import { pageSection, pageSectionPrint } from '../ElementConf/pageSection'

import $ from "jquery";
import Helper from "../Component/Helper";

export default function PageSection() {

    const { pageSize, setPageSize, afficheType,
        isPortrait, setIsPortrait, jsonFormat } = useContext(PageContext);

    const [afficheTypeTmp, setAfficheTypeTmp] = useState(afficheType);

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [isOpenAlertPaysage, setIsOpenAlertPaysage] = useState(false);

    function handleMoveCancel() {
        setIsOpenAlert(false)
        setIsOpenAlertPaysage(false)
    }

    function handleMoveConfirm(type: any) {
        if(type === "portrait")setIsOpenAlert(false);
        else if(type === "paysage")setIsOpenAlertPaysage(false);
        invertPortraitPayse(type)
    }

    function openAlert(type: any) {
        if(type === "portrait")setIsOpenAlert(true);
        else if(type === "paysage")setIsOpenAlertPaysage(true);
    }

    function heightChange(event: number) {
        if (setPageSize != null) setPageSize({ height: event, width: pageSize.width });
    }

    function widthChange(event: number) {
        if (setPageSize != null) setPageSize({ height: pageSize.height, width: event });
    }

    function changeTypeAffiche(event: string) {
        if (afficheTypeTmp != null) setAfficheTypeTmp(event);
    }

    function invertPortraitPayse(event: string) {
        if (event === 'portrait' && !isPortrait) {
            if (setPageSize != null) setPageSize({ height: pageSize.width, width: pageSize.height });
            if (setIsPortrait) setIsPortrait(true)
        }
        else if (event === 'paysage' && isPortrait) {
            if (setPageSize != null) setPageSize({ height: pageSize.width, width: pageSize.height });
            if (setIsPortrait) setIsPortrait(false)
        }
    }

    const listPageSection = pageSection.map((pageSectionItem: any) =>
        <PageSectionElem page={pageSectionItem} afficheTypeTmp={afficheTypeTmp} key={pageSectionItem.id} />
    );

    const listPageSectionPrint = pageSectionPrint.map((pageSectionItem: any) =>
        <PageSectionElem page={pageSectionItem} afficheTypeTmp={afficheTypeTmp} key={pageSectionItem.id} />
    );


    return (
        <div>
            <h2> Format de l'affiche</h2>

            <div>
                <div>Mon choix : </div>
            </div>

            <div className="subtitle-section">
                <h3 > Type de support </h3>
                <Helper text="Fais ton choix entre un format numérique téléchargeable instantanément ou une affiche imprimée qui te sera livrée à l’adresse de ton choix dans quelques jours" />
            </div>
            <div>
                <ButtonGroup className="btn-portrait">
                    <button className={"main-button2 " + (afficheTypeTmp === 'print' ? 'active' : '')} onClick={() => changeTypeAffiche('print')} >
                        <span>Impression</span>
                    </button>
                    <button className={"main-button2 " + (afficheTypeTmp === 'pdf' ? 'active' : '')} onClick={() => changeTypeAffiche('pdf')} >
                        Numérique
                    </button>
                </ButtonGroup>
            </div>

            <div className="subtitle-section">
                <h3 > Dimensions </h3>
                <Helper text="Pour les affiches imprimées, nous mettons à votre disposition trois options de formats​" img="Guide-des-tailles-Affiche-Map-Poster.png"/>
            </div>
            {afficheTypeTmp === 'print' && <div className='page-section-elem-list'>{listPageSectionPrint}</div>}
            {afficheTypeTmp === 'pdf' && <div className='page-section-elem-list'>{listPageSection}</div>}



            {(jsonFormat.id.includes('a4_page') || jsonFormat.id.includes('a3_page') || jsonFormat.id.includes('a2_page')) &&
                <div>
                    <div className="subtitle-section">
                        <h3 > Orientation </h3>
                        <Helper text="N'oublie pas de choisir dès le départ si tu préfères une disposition en portrait ou en paysage. Cela t'évitera de devoir refaire toute la mise en page personnalisée que tu as réalisée​" />
                    </div>
                    <div>
                        <ButtonGroup className="btn-portrait">
                            {/*<button className={"main-button2 " + (isPortrait ? 'active' : '')} onClick={() => invertPortraitPayse('portrait')} >
                                Portrait
                            </button>
                            <button className={"main-button2 " + (!isPortrait ? 'active' : '')} onClick={() => invertPortraitPayse('paysage')} >
                                Paysage
                            </button>*/}
                            <Alert
                                cancelButtonText="Retour"
                                confirmButtonText="Let's go"
                                icon="high-priority"
                                intent={Intent.SUCCESS}
                                isOpen={isOpenAlert}
                                onCancel={handleMoveCancel}
                                onConfirm={() => handleMoveConfirm('portrait')}
                                canOutsideClickCancel={true}
                                className="alert-modele"
                            >
                                <p>
                                    Etes-vous sûr de vouloir changer d'orientation en <b>'portrait'</b> ? La position des éléments ne seront pas adaptées.
                                </p>
                            </Alert>
                            <Alert
                                cancelButtonText="Retour"
                                confirmButtonText="Let's go"
                                icon="high-priority"
                                intent={Intent.SUCCESS}
                                isOpen={isOpenAlertPaysage}
                                onCancel={handleMoveCancel}
                                onConfirm={() => handleMoveConfirm('paysage')}
                                canOutsideClickCancel={true}
                                className="alert-modele"
                            >
                                <p>
                                    Etes-vous sûr de vouloir changer d'orientation en <b>'paysage'</b> ? La position des éléments ne seront pas adaptées.
                                </p>
                            </Alert>
                            <button onClick={() => openAlert('portrait')} className={"main-button2 " + (isPortrait ? 'active' : '')}>Portrait</button>
                            <button className={"main-button2 " + (!isPortrait ? 'active' : '')} onClick={() => openAlert('paysage')} >
                                Paysage
                            </button>

                        </ButtonGroup>
                    </div></div>}


            {(afficheType === 'pdf' && jsonFormat.id === 'format_libre') && <div>
                <div className="input-hw-map">
                    <label className="label-side-menu">Largeur </label>
                    <NumericInput id="map_width" max={1920} rightElement={<div className="numeric-inout-right-text">px</div>} onValueChange={widthChange} defaultValue={pageSize.width} value={pageSize.width} small={true} stepSize={1} />
                </div>
                <div className="input-hw-map">
                    <label className="label-side-menu">Hauteur</label>
                    <NumericInput id="map_height" max={1920} rightElement={<div className="numeric-inout-right-text">px</div>} onValueChange={heightChange} defaultValue={pageSize.height} value={pageSize.height} small={true} stepSize={1} />
                </div>
            </div>}
        </div>
    );
}

const PageSectionElem = (props: any) => {

    const pageElem = props.page;
    const afficheTypeTmp = props.afficheTypeTmp;

    const { setPageSize, setIsPortrait, jsonFormat, setJsonFormat, setAfficheType } = useContext(PageContext);

    /* Test if this format is selected */
    //on test aussi l'inverse pour le mode portrait ou paysage

    /*const isActive = (pageSize.width == pageElem.size.width && pageSize.height == pageElem.size.height && afficheTypeTmp == afficheType) ||
        (pageSize.width == pageElem.size.height && pageSize.height == pageElem.size.width  && afficheTypeTmp == afficheType) ? 'active' : '';*/


    const isActive = jsonFormat.id === pageElem.id ? 'active' : '';

    function changePageSize(event: any, json: any) {

        if (json.id !== 'format_libre') {
            if (setPageSize != null) setPageSize(json.size);
        }
        if (setJsonFormat != null) setJsonFormat(json);
        //on repasse en mode portrait par défaut
        if (setIsPortrait != null) setIsPortrait(true);
        if (setAfficheType != null) setAfficheType(afficheTypeTmp);

        const activeBtn = $('.page-section-elem.active');
        activeBtn.removeClass("active");
        event.target.classList.add("active");

    }

    return (
        <div className={'page-section-elem ' + isActive} onClick={(e) => changePageSize(e, pageElem)}>
            <div><img className="icon-side-menu" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/a4.svg"} alt="format"></img></div>
            <div className="page-text">
                {pageElem.text}
                {(pageElem.subtext != null) && <span className="subtext_format"> {pageElem.subtext} </span>}
            </div>
            {/*(pageElem.size.width != null || pageElem.size.width != null) && <div className="page-subtext"> <span>{pageElem.size.width} x {pageElem.size.height} px</span></div>*/}
            {<div className="page-subtext"> <span className="span-price"> {pageElem.price} €</span></div>}
        </div>
    )
}